import { useSyncExternalStore } from "react";
import {
    subscribeAdminPending,
    getAdminPendingCount,
} from "./adminPendingStore";

/**
 * Returns the live count of pending-verification dealers for the admin
 * header pill. `null` while not yet loaded, otherwise an integer (0+).
 *
 * The source of truth is the external store updated by
 * `useUserNotifications` (initial fetch + WS push events).
 */
export default function useAdminPendingCount() {
    return useSyncExternalStore(subscribeAdminPending, getAdminPendingCount, getAdminPendingCount);
}
